define('formkit/view/form/section/section.item.view',['require','exports','module','underscore','uikit/uikit','../../../form.object.util','../../../templates','../../../behavior/template.object.remove.reorder.behavior','../../../behavior/bind.option.to.active.section.change.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                       = require('underscore'),
      UIKit                                   = require('uikit/uikit'),
      FormObjectUtil                          = require('../../../form.object.util'),
      Templates                               = require('../../../templates'),
      TemplateObjectRemoveReorderBehavior     = require('../../../behavior/template.object.remove.reorder.behavior'),
      BindOptionToActiveSectionChangeBehavior = require('../../../behavior/bind.option.to.active.section.change.behavior');

  var UpdateFailedValidationStateBehavior = Mn.Behavior.extend({
    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);
      this.view.userHasRecentlyVisitedSection = false;

      this.listenToOnce(this.view, 'before:render', function() {
        this.setupView();
      });
    },

    setupView: function() {
      // update the icon view state if the form syncs with the remote server
      this.listenTo(this.view.form.getTemplateModel(),'sync', _.debounce(function() {
          this.updateState();
        })
      );

      // update the icon view state if a user directly interacts with the page by navigating to the section
      this.listenTo(this.view, 'section:pressed', function() {
        this.view.userHasRecentlyVisitedSection = true;
        this.updateState();
      });

      this.updateState();
    },

    // Crawls the templateObject tree of a section looking for any answer that has been previously modified, ie, whether
    // an answerValueCollection has been created for an answer, which only occurs if the user has answered the question.
    // NOTE: (MODEL.get('data') is the answerValueCollection)
    hasPreviouslyModifiedAnswerInSection: function(templateObject) {
      // a map that will evaluate each answer for a section and return 'true' if it has been previously modified.
      var hasModifiedAnswerArray = templateObject.map( function(model) {
        var parentAnswerModel = model.get('answer');        // Answers associated with the top level template object (ie, the main question)
        var childTemplateObjects = model.get('children');   // the template objects that would be associated with any compound template object (ie, items in a table);

        // Some compound form objects (ie, tables) can have answers at the root level of the object, and answers at the child level
        // as well.  We need to cycle thru those as well if they exist
        if (childTemplateObjects) {
          var childAnswerArray = childTemplateObjects.map(function(model) {
            var childAnswerModel = model.get('answer');

            return childAnswerModel && childAnswerModel.get('data').length > 0;
          });
        }

        // if we have a parentAnswerModel and it's been answered, or if any accompanying child answers exist, map this question
        // as having been previously answered;
        return (parentAnswerModel && parentAnswerModel.get('data').length > 0) || _.some(childAnswerArray);
      });

      // returns true if any item has been mapped to true;
      return _.some(hasModifiedAnswerArray)
    },

    updateState: function() {
      var failedValidationsCount = this.view.form.util.getFailedValidationsArray(this.view.model).length;
      var userHasVisitedSection = this.view.userHasRecentlyVisitedSection || this.hasPreviouslyModifiedAnswerInSection(FormObjectUtil.getLeafTemplateObjects(this.view.model));

      this.view.text = failedValidationsCount > 0 ? String(failedValidationsCount) : '';            // If there is a failedValidationsCount, show the number otherwise no text so we can display the icon
      this.view.color = userHasVisitedSection && failedValidationsCount === 0 ? 'green' : 'red';    // If the user has opened a section and our validation count is zero, icon color is green, otherwise red
      this.view.icon = failedValidationsCount > 0 ? '' : userHasVisitedSection ? 'check' : 'eye';   // If the user has a failed validation count, no icon, otherwise if they've viewed the section show the checkmark, otherwise the eye
    },
  });

  var SectionItemView = UIKit.ItemView.extend({
    className: 'form-section ui vertical segment',

    attributes: function() {
      return {
        'data-id': this.model ? this.model.id : null,
        tabindex: '0',
      };
    },

    template: Templates.App['section.item'],

    internalViewOptions: {
      labelView: function() {
        return {
          bindings: { text: 'label' },
          model: this.model,
        };
      },
      failedValidationsCountView: function() {
        return {
          type: UIKit.Button.extend({
            className: UIKit.Button.prototype.className + ' section failed validations',
          }),
          behaviors: {
            UpdateFailedValidationStateBehavior: {
              behaviorClass: UpdateFailedValidationStateBehavior,
            },
          },
          form: this.form,
          circular: true,
          model: this.model,
          visible: !this.getOption('designable'),
        };
      },
      textView: function() {
        return {
          bindings: { text: 'text' },
          model: this.model,
        };
      },
      dragBtn: {
        basic: true,
        floated: 'left',
        icon: 'move',
        inverted: false,
        size: 'small',
      },
      actionsView: function() {
        return {
          childBindings: { text: 'text' },
          circular: true,
          icon: 'ellipsis horizontal',
          iconOnly: true,
          color: 'white',
          mode: 'button',
          model: this.model,
          pointing: 'left',
          size: 'small',
          behaviors: {
            TemplateObjectRemoveReorderBehavior: {
              behaviorClass: TemplateObjectRemoveReorderBehavior,
              enableActions: this.getOption('enableActions'),
              form: this.form,
              canRemoveOnlyChild: true,
            },
          },
        };
      },
    },

    options: {
      active: false,
      enableActions: false,
      form: null,
      readonly: false,
    },

    forceUpdate: {
      enableActions: true,
      readonly: true,
    },

    ui: {
      controls: '.controls',
    },

    events: {
      click: 'handleClick',
      keydown: function(ev) {
        if (ev.keyCode === 13) {
          this.form.setActiveSectionModel(this.model);
        }
      },
    },

    behaviors: {
      BindOptionToActiveSectionChangeBehavior: {
        behaviorClass: BindOptionToActiveSectionChangeBehavior,
        optionName: 'active',
        valueWhenActive: true,
        valueWhenInactive: false,
      },
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.call(this, arguments);

      // If we have a model with an answerModel, get its readonly status, otherwise default to not readonly
      this.readonly = this.model && this.model.get('answer') ? this.model.get('answer').get('readOnly') : false;
    },

    onChangeActive: function() {
      if (this.actionsView) {
        this.actionsView.inverted = this.getOption('active');
        this.actionsView.color = this.getOption('active') ? '' : 'white';
      }
    },

    handleClick: function(ev) {
      var controlsContainer = this.ui.controls.get(0);

      if (!controlsContainer.contains(ev.target)) {
        this.triggerMethod('press');
      }
    },

    updateAttributes: function() {
      var active = this.getBoolOption('active');

      this.addClass('active', active);
      this.addClass('read-only', this.readonly);
    },

    onPress: function() {
      this.failedValidationsCountView.trigger('section:pressed');
      this.form.setActiveSectionModel(this.model);
    },
  });

  module.exports = SectionItemView;
});

